$(() => {
  const patient_discharges_per_year = () => {
    const net_pt_revenue = parseFloat($('#net-pt-revenue').val().replaceAll(',', ''));

    return Math.round(0.0000272 * net_pt_revenue);
  };

  const run = () => {
    if ($('#patient-discharges-per-year-overridden').val() === '0') {
      $('#patient-discharges-per-year').val(accounting.formatMoney(patient_discharges_per_year(), '', 0));
    }
  };

  run();

  $('#net-pt-revenue').change(() => {
    run();
  });

  $('#patient-discharges-per-year').blur(() => {
    $('#patient-discharges-per-year-overridden').val('1');
  });
});
